import { motion } from "framer-motion";
import { UserPlus, Lock, Sparkles, CalendarCheck, Receipt, Camera } from "lucide-react";

const steps = [
  {
    icon: UserPlus,
    step: "01",
    title: "Create a Krew",
    description: "Set the date, vibe, budget. Invite friends via WhatsApp link. Everyone sees who's in.",
  },
  {
    icon: Lock,
    step: "02",
    title: "Lock Commitment",
    description: "Each member locks a ₹500 deposit or pre-loads their share. Bail? Deposit goes to the group.",
  },
  {
    icon: Sparkles,
    step: "03",
    title: "AI Venue Match",
    description: "We analyze group size, budget, vibes & availability. You get 3 picks, not 50. Vote and go.",
  },
  {
    icon: CalendarCheck,
    step: "04",
    title: "Auto-Book & Pre-Pay",
    description: "Table booked, bottle service confirmed. Everyone gets the same QR — no confusion, no calls.",
  },
  {
    icon: Receipt,
    step: "05",
    title: "Auto-Settlement",
    description: "End of night? Final bill auto-splits. Everyone's payment method charged. Zero IOUs.",
  },
  {
    icon: Camera,
    step: "06",
    title: "Post-Night Social",
    description: "Shared photo album, venue ratings, Krew leaderboard. Next time: \"Invite your usual crew?\"",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="section-padding bg-card">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16 text-center"
        >
          <span className="mb-4 inline-block text-sm font-semibold uppercase tracking-widest text-primary">
            How It Works
          </span>
          <h2 className="text-4xl font-bold md:text-5xl">
            From chaos to <span className="text-gradient-neon">coordinated</span> in 5 minutes.
          </h2>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {steps.map((step, i) => (
            <motion.div
              key={step.step}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="group relative rounded-2xl border border-border bg-background p-8 transition-all hover:border-primary/40 hover:glow-neon"
            >
              <span className="absolute right-6 top-6 text-5xl font-bold text-muted/60">
                {step.step}
              </span>
              <div className="relative z-10">
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 transition-colors group-hover:bg-primary/20">
                  <step.icon className="h-6 w-6 text-primary" />
                </div>
                <h3 className="mb-2 text-xl font-semibold text-foreground">{step.title}</h3>
                <p className="text-sm leading-relaxed text-muted-foreground font-body">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
